import React from 'react';
import { Link } from 'react-router-dom';

function BlogTFourItem({ thumb, meta, title, category, slug }) {
    const linkPath = `/services/${slug}`;

    return (
        <div className="col-xl-3 col-md-6 col-12 mb-4">
            <Link to={linkPath}>
                <div className="single-news-card">
                    <div
                        className="featured-thumb bg-cover"
                        style={{ backgroundImage: `url(${thumb})` }}
                    />
                    {/* <img
                        className="featured-thumb bg-cover"
                        src={thumb} alt=""
                        loading='lazy'
                    /> */}
                    <div className="post-content flex-grow-1 d-flex flex-column">
                        {/* <div className="post-meta d-flex">
                        <div className="post-date ml-2">
                            <span>{meta}</span>
                        </div>
                    </div> */}

                        <h3 style={{ textTransform: 'capitalize' }}>
                            {title}
                        </h3>

                        {/* <Link
                        className="read-btn"
                        to={linkPath}
                    >
                        Read More
                    </Link> */}
                    </div>
                </div>
            </Link>
        </div>
    );
}

export default BlogTFourItem;